"use client";

import { useState, useRef } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroduccionEnVideo() {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const handlePlayClick = () => {
    setPlaying(true);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };
  return <section id="introducción-en-vídeo" className="relative w-full py-48 bg-[#1a1e14] overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_grove_process_pattern.png)] bg-repeat bg-center" style={{
      backgroundSize: "600px 600px",
      transform: "translateZ(0)"
    }} />

      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-5xl mx-auto space-y-16">
          {}
          <div className="relative aspect-video w-full rounded-lg overflow-hidden bg-black ring-1 ring-white/10">
            <iframe width="100%" height="600" src="https://www.youtube.com/embed/Bz8mIWopNNY" title="El Arte de la Extracción en Frío" frameborder="0" allowfullscreen>
</iframe>

            {}
            {!playing && <div className="absolute inset-0 flex items-center justify-center bg-black/20 backdrop-blur-sm transition-all duration-500 hover:bg-black/10 group cursor-pointer" onClick={handlePlayClick}>
                <Button variant="default" size="icon" className="size-24 rounded-full shadow-none bg-primary text-secondary hover:bg-primary-600 transition-transform duration-300 group-hover:scale-110" aria-label="Reproducir vídeo">
                  <Play className="size-10 fill-current ml-1" strokeWidth={1.5} />
                </Button>
              </div>}
          </div>

          {}
          <div ref={contentRef} className={`text-center space-y-8 transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-4xl lg:text-6xl font-serif font-medium text-[rgb(245,241,229)] tracking-tight leading-tight">
              Trazabilidad: Del Árbol a su Mesa
            </h1>

            <p className="text-lg lg:text-xl font-sans text-secondary/80 max-w-3xl mx-auto leading-relaxed">
              Nuestro compromiso con la honestidad y la transparencia nos impulsa
              a compartir cada paso del proceso. Desde el cuidado de nuestros
              olivos hasta el embotellado final, cada gota de aceite cuenta una
              historia de dedicación, tradición y respeto por la tierra. Descubra
              cómo llevamos el auténtico sabor mediterráneo directamente a su
              mesa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}